import { useEffect, useState } from "react";
import "./marketing.css";

const MESSAGES = [
  "Custom Amazon seller lists with ASIN-level intent signals.",
  "Drops into Clay, HeyReach, Lemlist, Smartlead, and HubSpot.",
] as const;

const INTERVAL_MS = 6000;

const ArrowOut = () => (
  <svg
    className="ls-announcement-arrow"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    aria-hidden="true"
  >
    <path d="M3.2 8.8 L8.8 3.2" strokeLinecap="round" />
    <path d="M4.6 3.2 L8.8 3.2 L8.8 7.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export function AnnouncementBar() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (MESSAGES.length <= 1) return;
    const id = window.setInterval(() => {
      setIdx((i) => (i + 1) % MESSAGES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div
      className="ls-announcement-bar"
      data-testid="announcement-bar"
      role="region"
      aria-label="Announcements"
    >
      <div className="ls-announcement-stage" aria-live="polite">
        {MESSAGES.map((m, i) => (
          <span
            key={i}
            className="ls-announcement-msg"
            data-active={i === idx ? "true" : "false"}
            aria-hidden={i === idx ? undefined : true}
          >
            <span>{m}</span>
            <ArrowOut />
          </span>
        ))}
      </div>
    </div>
  );
}
